
import { Injectable } from "@angular/core";
import { ROUTES } from "../constants/routes";
import { VOUCHER_MODULE_NAMES } from "../constants/enums";

@Injectable({
  providedIn: "root"
})
export class ModuleCheckerService {

  constructor() { }

  isMaxCafeModuleActive() {
    return this.getActiveModule() == ROUTES.HOME_CAFE;
  }

  isBettingModuleActive() {
    return this.getActiveModule() == ROUTES.HOME_BETTING;
  }

  isVouchersActive() {
    return this.getActiveModule() == VOUCHER_MODULE_NAMES.VOUCHERS;
  }

  isMyVouchersActive() {
    return this.getActiveModule() == VOUCHER_MODULE_NAMES.MY_VOUCHERS;
  }

  isMbcHistoryModuleActive() {
    return this.getActiveModule() == "mbc-expired";
  }

  getActiveModule() {
    return sessionStorage.getItem("selectedModule") !== null ?
      sessionStorage.getItem("selectedModule") : ROUTES.HOME_CAFE;
  }
}
